import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { API_KEY_CATALOGS } from "./model/api-key-copy.ts";
import { API_KEYS_ERROR_COPY } from "./model/api-key-error-copy.ts";

// Customer API keys under Settings (S4.09), admin-only: the door itself refuses a member or
// viewer (`apikeys:read`/`apikeys:write`), and a 403 on the list already renders the "no
// access" boundary, so this screen needs no role check of its own.
// Settings → Enterprise hides behind `enterprise-settings` (S43.05, D1370).
export const apikeysBrowserModule: BrowserModule = defineBrowserModule("apikeys")
  .withErrorCopy(API_KEYS_ERROR_COPY)
  .withScreens({
    apiKeys: {
      path: "/settings/api-keys",
      title: phrase(API_KEY_CATALOGS, "screenTitle"),
      layout: "app",
      flag: "enterprise-settings",
      load: () => import("./ui/sections/api-keys-screen.tsx"),
    },
  })
  .withNavigation([
    {
      id: "api-keys",
      group: "settings-enterprise",
      label: phrase(API_KEY_CATALOGS, "navApiKeys"),
      href: "/settings/api-keys",
      icon: "lock",
      order: 870,
      flag: "enterprise-settings",
    },
  ]);
